const infoCards = [
  {
    icon: "ri-ticket-line",
    title: "Inscrições & Vagas",
    iconBg: "bg-[#F0CDCD]/60",
    iconColor: "text-[#008C51]",
    items: [
      "Participação gratuita, mediante inscrição prévia",
      "Inscrições abrem em 02/04/2026 às 10h00",
      "Escolha suas modalidades no momento da inscrição e garanta sua vaga",
      "Vagas limitadas, sujeitas à lotação",
    ],
  },
  {
    icon: "ri-shield-check-line",
    title: "Kit & Credenciamento",
    iconBg: "bg-[#CDE3BB]",
    iconColor: "text-[#008C51]",
    items: [
      "Credenciamento e retirada de kits acontecem no dia do evento",
      "Apresente confirmação de inscrição",
      "O kit é pessoal e intransferível",
      "Tamanhos de camiseta sujeitos à disponibilidade",
      "Kits não serão entregues após o evento e a retirada através de terceiros não está autorizada",
    ],
  },
  {
    icon: "ri-building-2-line",
    title: "Estrutura do Evento",
    iconBg: "bg-[#A4D8DE]/50",
    iconColor: "text-[#008C51]",
    items: [
      "Áreas de convivência e descanso",
      "Pontos de hidratação",
      "Guarda-volumes disponível",
      "Espaço kids: vagas limitadas",
    ],
  },
  {
    icon: "ri-parking-line",
    title: "Informações Práticas",
    iconBg: "bg-[#CDE3BB]/60",
    iconColor: "text-[#008C51]",
    items: [
      "R. Líbero Leone, 259 – Buritis, BH",
      "Estacionamento gratuito no local (sujeito à lotação)",
      "Não é permitida a entrada de animais de estimação",
      "Venha com roupa confortável e tênis",
    ],
  },
];

export default function AdditionalInfo() {
  return (
    <section id="informacoes" className="py-20 bg-[#CDE3BB]/20">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-14">
          <span className="text-[#BCD033] text-sm font-bold tracking-widest uppercase">Tudo que você precisa saber</span>
          <h2 className="text-4xl font-extrabold text-[#008C51] mt-2">Informações Importantes</h2>
          <p className="text-gray-500 mt-3 text-sm max-w-lg mx-auto">
            Prepare-se para aproveitar ao máximo essa manhã. Leia com atenção antes de se inscrever!
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-10">
          {infoCards.map((card) => (
            <div
              key={card.title}
              className="rounded-2xl border border-[#CDE3BB]/60 bg-white p-6 hover:bg-[#CDE3BB]/10 transition-colors"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className={`w-11 h-11 flex items-center justify-center rounded-xl ${card.iconBg}`}>
                  <i className={`${card.icon} text-xl ${card.iconColor}`} />
                </div>
                <h3 className="font-extrabold text-[#008C51] text-lg">{card.title}</h3>
              </div>
              <ul className="flex flex-col gap-2">
                {card.items.map((item, idx) => (
                  <li key={idx} className="flex items-start gap-2 text-sm text-gray-600">
                    <i className="ri-checkbox-circle-line text-[#BCD033] mt-0.5 flex-shrink-0" />
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="rounded-2xl bg-gradient-to-r from-[#CDE3BB] to-[#A4D8DE]/50 p-6 flex flex-col md:flex-row items-center gap-4">
          <div className="w-12 h-12 flex items-center justify-center bg-white rounded-xl flex-shrink-0">
            <i className="ri-map-pin-2-fill text-2xl text-[#BCD033]" />
          </div>
          <div className="flex-1 text-center md:text-left">
            <p className="font-bold text-[#008C51]">Arena 4Set — Buritis, Belo Horizonte</p>
            <p className="text-sm text-gray-600">R. Líbero Leone, 259 – Buritis, Belo Horizonte – MG</p>
          </div>
          <a
            href="https://maps.google.com/?q=R.+Líbero+Leone,+259+Buritis+Belo+Horizonte"
            target="_blank"
            rel="nofollow noopener noreferrer"
            className="bg-[#008C51] text-white text-sm font-bold px-5 py-2.5 rounded-full hover:bg-[#007040] transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-map-2-line mr-1" />
            Ver no mapa
          </a>
        </div>
      </div>
    </section>
  );
}
